import {useEffect, useState} from 'react'
import DesignExterno from '../../components/DesignExterno/DesignExterno'
import {DICCIONARIO} from '../../constants/Diccionario'
import {useHistory} from 'react-router'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {bindActionCreators} from 'redux'
import {actionCreacionUsuario, actionValidatorsCreacionUsuario} from '../../actions/action-creators'
import {KEYS} from '../../constants/keysStorage'
import {Link} from 'react-router-dom'
import ModalConfirmacionCuenta from './ModalConfirmacionCuenta'
import ModalCodigoEnviado from '../../components/Modals/ModalsCreacion/ModalCodigoEnviado'
import {creacionUsuarioClear} from '../../actions/creacion-usuario/creacionUsuario.actions'

const ConfirmacionCuenta = (props: any) => {
  const [disable, setDisable] = useState(true)
  const history = useHistory()
  const [openModal, setOpenModal] = useState(false)
  const [openModal2, setOpenModal2] = useState(false)
  const verifyCode = useSelector((state: State) => state.creacionUsuario.codeVerify)
  const dispatch = useDispatch()

  const actionsCreate = bindActionCreators(actionCreacionUsuario, dispatch)
  const validaciones = bindActionCreators(actionValidatorsCreacionUsuario, dispatch)

  useEffect(() => {
    const username = localStorage.getItem(KEYS.USERNAME_CLIENTE)
    if (!username) {
      login()
      return
    }

    return () => {
      dispatch(creacionUsuarioClear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (verifyCode.code && !verifyCode.error) setDisable(false)
    else setDisable(true)
  }, [verifyCode])

  const submit = async (e: any) => {
    e.preventDefault()
    if (await validaciones.validacionesCreacionUsuarioVerificarCodigoSiguiente()) return
    if (await actionsCreate.creacionUsuarioVerificarCodigoEmail()) {
      const interno = localStorage.getItem(KEYS.INTERNO)
      if (interno === '1') restore()
      else setOpenModal(true)
    }
  }

  const reenviarCodigo = async () => {
    if (await actionsCreate.creacionUsuarioReenviarCodigo()) setOpenModal2(true)
  }

  const login = () => {
    setOpenModal(false)
    localStorage.removeItem(KEYS.USERNAME_CLIENTE)
    localStorage.removeItem(KEYS.USERNAME_CLIENTE_RESTORE)
    localStorage.removeItem(KEYS.INTERNO)
    localStorage.removeItem(KEYS.TOKEN)
    history.push('/')
  }

  const restore = () => {
    setOpenModal(false)
    const username = localStorage.getItem(KEYS.USERNAME_CLIENTE) || ''
    localStorage.setItem(KEYS.USERNAME_CLIENTE_RESTORE, username!)
    history.push('/user-restore')
  }

  return (
    <DesignExterno title={<span>Confirma tu cuenta</span>}>
      {openModal && <ModalConfirmacionCuenta handleClose={login} />}
      {openModal2 && <ModalCodigoEnviado onClose={() => setOpenModal2(false)} />}
      <section className='centrar-horizontal'>
        <div className='w-form form-content'>
          <Link to='/' className='back-button w-inline-block'></Link>
          <form
            className='form-content'
            data-wf-page-id='64af244a307770eac998c0c4'
            data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
            onSubmit={submit}
          >
            <div>
              <h3 className='h3-titles xl'>Verificación de correo electrónico</h3>
              <div>Ingresa el código de verificación que fue enviado a tu correo electrónico,</div>
              <div>al momento de que creaste tu cuenta de usuario</div>
            </div>
            <div className='form-separator'></div>
            <div>
              <label htmlFor='idCode' className='field-label m'>
                {DICCIONARIO.CODIGO_VERIFICACION}
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                maxLength={20}
                autoFocus
                name='code'
                data-name=''
                placeholder={DICCIONARIO.CODIGO_VERIFICACION}
                id='idCode'
                value={verifyCode.code}
                onChange={actionsCreate.creacionUsuarioFormVerifyCodeHandleChange}
                onBlur={validaciones.validacionesCreacionUsuarioVerificarCodigo}
              />
              {verifyCode.error && <p className='alert s'>{verifyCode.error}</p>}
            </div>
            <div className='div-reenviar-codigos' style={{margin: '7% 0 2%'}}>
              <div>¿No te ha llegado tu código?</div>
              <button
                type='button'
                className='m button-reenviar-codig-text2'
                onClick={reenviarCodigo}
              >
                Reenviar código
              </button>
            </div>
            <div
              className='w-layout-hflex button-actions'
              style={{width: '60%', margin: '0 auto 5%'}}
            >
              <button type='submit' className='m button w-inline-block' disabled={disable}>
                Enviar
              </button>
            </div>
          </form>
        </div>
      </section>
    </DesignExterno>
  )
}

export default ConfirmacionCuenta
